import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "../base-service";
import { Storage } from '@ionic/storage';
import {Driver, DriverGroup} from "../../models/driver";
import {Observable} from "rxjs/Observable";
import {AppConfig} from "../../config/appconfig";
import {IWorkRestModesReportParameters, IWorkRestVehicleModesReportParameters} from "../../models/reports/i-work-rest-modes-report-parameters";
import {dddFile} from "../../models/dddFile";

/*
  Generated class for the DriverServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class DriverServiceProvider extends BaseService {

  private readonly driversUrl: string = AppConfig.apiBaseUrl + "drivers";

  private readonly modesUrl: string = AppConfig.apiBaseUrl + "tacho";

  private readonly cardFilesUrl: string = this.driversUrl + "/" + "cardFiles";

  private readonly cardFileUrl : string = this.driversUrl + "/" + "cardFileDownload";

  private readonly cardXmlFileUrl : string = this.driversUrl + "/" + "cardXmlDownload";

  private readonly driverGroupsUrl: string = this.driversUrl + "/" + "drivergroups";

  private readonly companiesUrl: string = this.driversUrl + "/" + "companies";

  constructor(
    public http: Http,
    public storage: Storage
  ) {
    super(http, storage);
    //this.storage.clear().then();
  }

  private preformatDrivers(drvs: Driver[], filter: string = null): Driver[]{
    if(drvs){
      let sorted = drvs.filter((d) => {
        if(!filter){
          return d;
        }

        // AS: check driver name
        // split it into name components
        let name = d.name.toLowerCase().split(' ').map((n) => {
          return n.trim();
        }).filter((n) => {
          if(n.indexOf(filter) >= 0){
            return n;
          }
        });
        if(name && name.length > 0){
          return d;
        }

        // AS: check card number
        if(d.cardNumber && d.cardNumber.toLowerCase().indexOf(filter) == 0){
          return d;
        }

      })
      // AS: sort it by name
        .sort((d1, d2) => {
          let name1 = d1.name ? d1.name.toLowerCase() : null;
          let name2 = d2.name ? d2.name.toLowerCase() : null;

          if(name1 == null){
            return -1;
          }

          if(name2 == null){
            return 1;
          }

          if(name1 > name2){
            return 1;
          }

          if(name1 < name2){
            return -1;
          }

          return 0;
        });

      return sorted;
    }

  }

  public getDrivers(search: string = null, clearStorage: boolean = false) : Promise<Driver[]>{
    return new Promise<Driver[]>((resolve, reject) => {

      if(clearStorage)
        this.storage.clear();

      let filter = search ? search.trim().toLowerCase() : null;

      let drvs: Driver[] = null;
      this.getDriversFromCache().subscribe(
        cachedrvs => {
          if(cachedrvs && cachedrvs.length > 0){
            drvs = cachedrvs;
            drvs = this.preformatDrivers(drvs, filter);
            return resolve(drvs);
          }else{
            this.getDriversFromServer().subscribe(
              remotedrvs => {
                this.storage.set("drivers", remotedrvs)
                  .then(
                    () => {
                      drvs = remotedrvs;
                      drvs = this.preformatDrivers(drvs, filter);
                      return resolve(drvs);
                    }).catch(
                      err => {
                        console.log(err);

                        // AS: ошибка ошибкой, но раз водителей показали, надо будет их отобразить
                        drvs = this.preformatDrivers(drvs, filter);
                        return resolve(drvs);
                      }
                    );
              },
              err => {
                console.log(err);
                return reject(err);
              }
            );
          }
        },
        err => {
          console.log(err);
          return reject(err);
        }
      );

      this.getDriversFromServer().subscribe(
        drvs => {

          return resolve(drvs);

        },
        err => {
          console.log(err);
          return reject(err);
        }
      );
    }).then().catch();
  }

  private getDriversFromCache(): Observable<Driver[]>{
    return new Observable<Driver[]>(observer => {
      this.storage.get("drivers")
        .then(drivers => {
          observer.next(drivers);
          observer.complete();
        })
        .catch(err => {
          console.log(err);
          observer.error(err);
        })
    });
  }

  private getDriversFromServer(): Observable<Driver[]>{
    return this.http.get(
      this.driversUrl,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  private  getDriverGroupsFromServer(): Observable<DriverGroup[]>{
    return this.http.get(
      this.driverGroupsUrl,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  private getCompaniesFromServer(): Observable<any[]> {
    return this.http.get(
      this.companiesUrl,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  public getDriverGroups(): Promise<DriverGroup[]>{
    return new Promise<DriverGroup[]>( (resolve, reject) => {
      this.getDriverGroupsFromServer().subscribe(
        drvgrps => {

          return resolve(drvgrps);

        },
        err => {
          console.log(err);
          return reject(err);
        }
      );
    });
  }

  public getCompanies(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.getCompaniesFromServer().subscribe(
        companies => {

          return resolve(companies);

        },
        err => {
          console.log(err);
          return reject(err);
        }
      );
    });
  }

  public updateDriver(d: Driver): Observable<Driver>{
    if(d == null){
      return new Observable<Driver>(observer => {
        observer.error(new Error("Не переданы данные по водителю"));
      });
    }

    let observable: Observable<Response>;
    if(d.id !== null && d.id > 0){
      observable = this.http.put(
        this.driversUrl,
        d,
        {headers: this.headers}
      );
    }else{
      observable = this.http.post(
        this.driversUrl,
        d,
        {headers: this.headers}
      );
    }

    return observable.map(
      (res:Response) =>
      {
        let body = res.json();
        let d = body || {};
        return d;
      }
    );
      //.catch(this.handleError);
  }

  // AS: режимы труда и отдыха
  public getDriverModes(p:IWorkRestModesReportParameters): Observable<any>{
    let url = this.modesUrl + "/driverworkmodes/";

    return this.http.post(
      url,
      p,
      {headers: this.headers})
      .map((res:Response) =>
      {
        let body = res.json();
        let d = body || {};
        return d;
      });
  }

  public getVehicleModes(p: IWorkRestVehicleModesReportParameters): Observable<any> {
    let url = this.modesUrl + "/vehicleworkmodes/";

    return this.http.post(
      url,
      p,
      { headers: this.headers })
      .map((res: Response) => {
        let body = res.json();
        let d = body || {};
        return d;
      });
  }

  public getDddFiles(driverId: number) : Observable<dddFile[]>{
    let url = this.cardFilesUrl + "/" + driverId;
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  public LoadCardFile(fileInfo: dddFile) : Observable<Response>{
    let url = this.cardFileUrl + "/" + fileInfo.FileId;

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return res;
      });
  }

  public LoadXmlCardFile(fileInfo: dddFile) : Observable<Response>{
    let url = this.cardXmlFileUrl + "/" + fileInfo.FileId;

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/driver-service/driver-service.ts